Ext.define('SA.Exports', {
    singleton: true,

    formats: {
        csv: 'application/csv',
        jpeg: 'image/jpeg',
        pdf: 'application/pdf',
        png: 'image/png',
        svg: 'image/svg+xml',
        xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        zip: 'application/dbf'
    },

    export({isDownload, resource, model, extension, params, emailParams}) {
        var viewId = model.getId(),
            viewName = model.getName(),
            projectName = model.getProject().getName(),
            asFile = this.getFilename({viewName, projectName, fileFormat: extension}),
            format = this.formats[extension];

        Object.assign(params, {viewId, asFile});

        if (isDownload) {
            this.exportByDownload({resource, format, params});
            return;
        }

        this.exportByEmail({resource, format, params, emailParams});
    },

    async exportByDownload({resource, format, params}) {
        var filename = params.asFile,
            blob = await SA.Ajax.request({blob: true, method: 'download', resource, format, data: {...params}}),
            url = URL.createObjectURL(new File([blob], filename)),
            link = SA.Html.create({type: 'a', href: url, download: filename});

        link.click();

        URL.revokeObjectURL(url);
    },

    exportByEmail({resource, format, params, emailParams}) {
        var {address: emailAddress, message} = emailParams,
            data = Object.assign({format, emailAddress, message}, params),
            success = () => SA.msg('Your export was processed successfully.\n\nAn email has been sent.');

        SA.Ajax.request({method: 'email', resource, data, success});

        SA.msg('Your export is being processed.\n\nYou will receive an email shortly.');
    },

    exportChart({viewId, svg, isDownload, filenameInfo, emailInfo: emailParams}) {
        var resource = 'chart',
            asFile = this.getFilename(filenameInfo),
            format = this.formats[filenameInfo.fileFormat],
            params = {asFile, viewId, dpi: 300, chart: SA.Svg.toXmlString(svg)};

        if (isDownload) {
            this.exportByDownload({resource, format, params});
            return;
        }

        this.exportByEmail({resource, format, params, emailParams});
    },

    getAliasExpression({attribute, alias}) {
        return ['with', attribute, alias];
    },

    getColumnExpressions({attributes, baseColumns, country, filter, filterVisibility, geographicUnit}) {
        var expressions = baseColumns.map(attribute => {
            if (attribute === 'geographicUnitName') {
                return this.getAliasExpression({attribute, alias: 'Geographic Unit'});
            }
            else if (attribute === 'name') {
                return this.getAliasExpression({attribute, alias: 'Name'});
            }
            else if (attribute === 'spatialId') {
                let alias = SA.model.Country.get(country).getSpatialIdColumnExportName({geographicUnit});

                return this.getAliasExpression({attribute, alias});
            }
            else {
                return attribute;
            }
        });

        if (filter && filterVisibility === 'strikeout') {
            expressions.push(this.getStrikeoutFilterExpression(filter));
        }

        expressions.push(...attributes.map(attribute => {
            var alias = SA.BadgedAttributeLabel.getText({attribute});

            return this.getAliasExpression({attribute, alias});
        }));

        return expressions;
    },

    getFilename({viewName, projectName, fileFormat}) {
        var dateTime = Ext.util.Format.date(new Date(), 'Y-m-d_H-i-s'),
            filename = `${projectName}_${viewName}_${dateTime}.${fileFormat}`;

        return filename.replace(/[^\w\- .()[\]]/g, '_');
    },

    getStrikeoutFilterExpression(filter) {
        return ['with', ['if', filter, 'false', 'true'], 'Filtered Out'];
    }
});